export default __webpack_public_path__ + "static/applet-04-set-1-fca56eedc05c3678c5b032d715d705b2.webp";